export default [
  {
    title: "แผนประกันภัยที่อยู่อาศัยแบบประหยัด",
    link: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    file_name: "Dummy.pdf"
  }
]